<template>
    <div class="vm-login-mobile mt-48-32 mq">
        <div class="relative">
            <input
                type="text"
                class="gl-input"
                :placeholder="$t('c.LoginMobile.text4')"
                v-model="account"
            >
            <span
                class="code-btn pointer purple"
                v-if="!is_hide_send_btn && !is_sent"
                @click="send"
            >{{$t('c.LoginMobile.text1')}}</span>
            <span class="code-btn black-1" v-if="is_sent">{{$t('c.LoginMobile.text2')}}（
                <span>{{ time }}</span>s）
            </span>
        </div>
        <div class="mt-44-28 mq relative" v-if="!is_message_expires">
            <input type="text pointer" class="gl-input" :placeholder="$t('c.LoginMobile.text3')" v-model="code">
        </div>
    </div>
</template>

<script>
import {
    POST_QUICK_LOGIN_CODE,
    POST_QUICK_LOGIN,
    POST_ACCOUNT_SEND_VERIFY_CODE,
    POST_ACCOUNT_BIND,
} from "@/api/config";
import { mapState } from "vuex";

export default {
    name: "login-mobile",
    props: {
        // placeholder_account: {
        //     type: String,
        //     default() {
        //         return "验证手机 / 海外手机请填邮箱";
        //     },
        // },
        is_hide_send_btn: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        // let is_sent = localStorage.getItem('is_')
        let last_send_time = localStorage.getItem('last_send_time') || '';
        let last_send_accout = localStorage.getItem('last_send_accout') || '';
        let is_message_expires = true;
        let time = 180;
        let is_sent = false;
        if(last_send_time){
          let diff = new Date().getTime() - last_send_time * 1
          if(diff < 1000 * 60 * 3){ //没过期 且 具体上一次发送小于 3分钟
            time = 180 - parseInt(diff / 1000);
            is_sent = true;
          }
          if(diff < 1000 * 60 * 30){ //没过期
            is_message_expires = false;
          }else{ //过期
            localStorage.setItem('last_send_time', '');
          }
        }

        return {
            fr: this.$route.query.fr || '',
            account: last_send_accout,
            code: "",
            is_sent,
            time,
            go: null,
            last_send_time,
            is_message_expires,
        };
    },
    computed: {
        ...mapState("app", ["mp_token", "session_user"]),
    },
    watch: {
        is_sent(val) {
            this.$emit("send_status", val);
        },
        time(val) {
            if (val == 0) {
                this.time = 180;
                this.is_sent = false;
                if (this.go) {
                    clearInterval(this.go);
                    this.go = null;
                }
            }
        },
    },
    mounted() {
      if(this.time != 180 ){
        this.timimg()
      }
    },
    methods: {
        timimg() {
            this.go = setInterval(() => {
                this.time--;
            }, 1000);
        },
        async send() {
            if(this.account.indexOf('@bestlistbase.com') != -1){
                return false
            }

            let API =
                this.session_user && !this.mixin_is_bind_session_user
                    ? POST_ACCOUNT_SEND_VERIFY_CODE
                    : POST_QUICK_LOGIN_CODE;
            if (this.$http.is_run(API)) {
                return false;
            }

            let data = await this.$http.$axios(API, { account: this.account });

            this.$notify({
                title: data.em,
                group: data.ec == 200 ? "success" : "error",
            });

            if (data.ec == 200) {
                this.is_sent = true;
                localStorage.setItem('last_send_time', new Date().getTime());
                localStorage.setItem('last_send_accout', this.account);
                this.is_message_expires = false;
                this.timimg();
                return true;
            } else {
                return false;
            }
        },
        async confirm() {
            if (this.account == "") {
                this.$notify({
                    title: "验证手机 / 海外手机请填邮箱",
                    group: "error",
                });
                return false;
            }

            if (this.account != "" && this.code == "") {
                this.$notify({
                    title: "请填写验证码",
                    group: "error",
                });
                return false;
            }

            let API =
                this.session_user && !this.mixin_is_bind_session_user
                    ? POST_ACCOUNT_BIND
                    : POST_QUICK_LOGIN;

            let post_data =
                this.session_user && !this.mixin_is_bind_session_user
                    ? { account: this.account, code: this.code }
                    : {
                          account: this.account,
                          code: this.code,
                          mp_token: this.mp_token,
                      };

            if (this.$http.is_run(API)) {
                return false;
            }

            let data = await this.$http.$axios(API, post_data);

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
                return false;
            }

            if (data.ec == 200) {
                this.$notify({
                    title: "验证成功",
                    group: "success",
                });
                localStorage.removeItem('last_send_time');
                localStorage.removeItem('last_send_accout');
                if(this.fr == 'wx'){
                    if (this.redirect_url) {
                        this.$router.replace({ path: this.redirect_url });
                        this.$store.commit('app/set:redirect_url', '');
                        return false;
                    }
                    this.$router.push('/feed');
                }
                if (data.data.auth_token) {
                    this.$bus.$emit("SESSION_LOGIN", data.data.auth_token);
                }
            }
            return true;
        },
    },
};
</script>

<style lang="stylus" scoped>
.vm-login-mobile {
    .code-btn {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        padding: px2rem(10);
    }
}
</style>
